import { Stack, StackProps } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigationType } from 'react-router-dom';

const variants = {
	PUSHVariants: {
		initial: { x: window.innerWidth * 0.75, opacity: 0 },
		animate: {
			x: 0,
			opacity: 1,
			transition: {
				type: 'spring',
				stiffness: 150,
				mass: 0.3,
				duration: 0.2,
			},
		},
		exit: { x: 0, opacity: 0, transition: { duration: 0.2 } },
	},
	POPVariants: {
		initial: { x: 0, opacity: 0 },
		animate: {
			x: 0,
			opacity: 1,
			transition: { duration: 0.5 },
		},
		exit: {
			x: window.innerWidth,
			opacity: 0,
			transition: { duration: 0.2 },
		},
	},
	REPLACEVariants: {
		initial: { x: 0, opacity: 1 },
		animate: {
			x: 0,
			opacity: 1,
		},
		exit: { x: 0, opacity: 0, transition: { duration: 0.2 } },
	},
};

const MotionWrapper: React.FC<
	Omit<StackProps, 'children'> & { component?: React.ElementType }
> = ({ children, ...restProps }) => {
	const action = useNavigationType();

	return (
		<Stack
			component={motion.div}
			variants={variants[`${action}Variants`]}
			initial="initial"
			animate="animate"
			exit="exit"
			spacing={2}
			overflow="scroll"
			{...restProps}
		>
			{children}
		</Stack>
	);
};

export default MotionWrapper;
